import { render, staticRenderFns } from "./TutorListAddNew.vue?vue&type=template&id=22c9c8ff&"
import script from "./TutorListAddNew.vue?vue&type=script&lang=js&"
export * from "./TutorListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./TutorListAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports